<script>
import formatDateRelative from '@utils/format-date-relative.js'

export default {
  name: 'ReactiveRelativeTime',
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timestamp: '',
      interval: null,
    }
  },
  mounted() {
    // Init time
    this.timestamp = this.convertToRelative()

    // Every 60 seconds set new relative time
    this.interval = setInterval(() => {
      this.timestamp = this.convertToRelative()
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    convertToRelative() {
      return !this.date ? '' : formatDateRelative(this.date, undefined, true)
    },
  },
}
</script>

<template>
  <div>
    {{ timestamp }}
  </div>
</template>
